import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { urls } from 'helpers/url';
import { navigate } from 'actionCreators';
import { updatePhaseTask } from 'actionCreators/phase';
import PhaseTask from './phase_task';
import PhaseType from 'types/phase';
import TaskType from 'types/task';

export class FollowUpDeliveryCall extends PhaseTask {
  isDisabled = () => false

  onClick = () => (this.props.task.status !== 'complete' ?
  this.props.navigate(urls.phaseCommunications(this.props.phase)) :
  this.toggleStatus());
}

FollowUpDeliveryCall.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
};

const follow_up_delivery_call = connect(() => state => ({ user: state.user }),
  { updatePhaseTask, navigate })(FollowUpDeliveryCall);

export { follow_up_delivery_call };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/follow_up_delivery_call.jsx